// React Imports
import * as React from "react";
import {useDispatch, useSelector} from "react-redux";


// Mui Imports
import MenuItem from "@mui/material/MenuItem";
import {
    ListItemIcon,
    ListItemText,
    Tooltip
} from "@mui/material";



// App Imports

import Box from "@mui/material/Box";
import PersonIcon from "@mui/icons-material/Person";


// main function
export default function PopulateContract({ onMenuClose, rowContractData }) {

    // ****************** BEGIN DISPATCH ****************************

    const dispatchData = useDispatch();

    // ****************** END DISPATCH ****************************



    return (

        <Box>
            {(rowContractData.contractLevel === "X") &&
                <MenuItem>
                            <ListItemIcon>
                                <PersonIcon fontSize="small"/>
                            </ListItemIcon>
                            <ListItemText>Populate</ListItemText>
                </MenuItem>
            }
        </Box>

    )

}
